export default __webpack_public_path__ + "static/media/whatsapp.d85a99ae.svg";